const VARIANTS_CLASSNAME = 'blaze-ecommerce-variants';
const DEFAULT_NOT_AVAILABLE_MESSAGE = 'Not available in your region';

export { VARIANTS_CLASSNAME, DEFAULT_NOT_AVAILABLE_MESSAGE };
